import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content"]
  static values = { key: String }

  connect() {
    if (this.stored() === "closed") this.set(false)
  }

  toggle() {
    const open = this.contentTarget.hidden

    this.set(open)
    this.store(open ? "open" : "closed")
  }

  set(open) {
    this.contentTarget.hidden = !open
    this.buttonTarget.setAttribute("aria-expanded", String(open))
  }

  stored() {
    try {
      return localStorage.getItem(this.storageKey)
    } catch (e) {
      return null
    }
  }

  store(state) {
    try {
      localStorage.setItem(this.storageKey, state)
    } catch (e) {
      console.warn("collapse state not saved", e)
    }
  }

  get storageKey() {
    return `pay-collapse-${this.keyValue}`
  }
}
